import { type ClassValue, clsx } from "clsx";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { twMerge } from "tailwind-merge";
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function convertTohHumanFileSize(size: number) {
  const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (
    +(size / Math.pow(1024, i))?.toFixed(2) * 1 +
    " " +
    ["B", "KB", "MB", "GB", "TB"][i]
  );
}

export const formatNumberToFrench = (
  value: number,
  options?: {
    style?: Intl.NumberFormatOptions["style"];
    currency?: Intl.NumberFormatOptions["currency"];
    displaySign?: boolean | Intl.NumberFormatOptions["signDisplay"];
    maximumFractionDigits?: number;
  },
) => {
  const {
    style = "currency",
    currency = "EUR",
    displaySign = "negative",
    maximumFractionDigits = 0,
  } = options || {};

  // 💡 Format français classique avec signe et devise
  let formatted = Intl.NumberFormat("fr-FR", {
    style,
    currency,
    signDisplay:
      typeof displaySign === "boolean"
        ? displaySign
          ? "always"
          : "never"
        : displaySign,
    maximumFractionDigits,
    useGrouping: true,
  }).format(value);

  // 🔹 Remplacement de TOUS les types d'espaces insécables
  //    - \u00A0 : espace insécable classique
  //    - \u202F : espace fine insécable (celle utilisée par Intl)
  formatted = formatted.replace(/[\u00A0\u202F]/g, " ");

  return formatted;
};

/**
 * @deprecated use `formatNumberToFrench` instead.
 */
export function formatNumberToFrenchFormat(
  value: number,
  options?: {
    currency?: string | boolean;
    displaySign?: boolean;
  },
) {
  const { currency = "€", displaySign = true } = options || {};

  const displayCurrency =
    typeof currency === "string" ? currency : currency ? "€" : "";

  return `${displaySign ? (value !== 0 ? (value > 0 ? "+" : "-") : "") : ""} ${Math.abs(
    Math.round(value),
  )
    .toFixed(0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${displayCurrency}`.trim();
}

export function getLastDayOfYearDetailed(year: number): string {
  const lastDay = new Date(year, 11, 31);
  return format(lastDay, "dd/MM/yyyy");
}

export function getFirstDayOfYearDetailed(year: number): string {
  const firstDay = new Date(year, 0, 1);
  return format(firstDay, "dd/MM/yyyy");
}

export function checkIfDateIsInYearDateRange(
  input: string,
  year: number,
): boolean {
  const firstDay = new Date(year, 0, 1);
  const lastDay = new Date(year, 11, 31);
  const date = new Date(input);
  return firstDay <= date && date <= lastDay;
}

export function dateFormatterFrench(
  date: Date | string,
  formatString = "dd/MM/yyyy",
): string {
  return format(new Date(date), formatString, { locale: fr });
}
